import baseAPI from '@/http'

const router = 'api/territorios-responsaveis'

export const territorioResponsavelAPI = {
  create: (city) => baseAPI.post(router, city),
  update: (city) => baseAPI.put(router, city),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
}
